import Icon from "@react-native-vector-icons/material-design-icons/static";
import { Searchbar, type SearchbarProps } from "react-native-paper";
import Box from "../Box";

import { useState } from "react";
import { TouchableOpacity } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import type { ToolActionProps } from "../TextModeChatComposer/ToolAction";
import ToolAction from "../TextModeChatComposer/ToolAction";
import TooltipWrapper from "../TooltipWrapper";

export type VoiceModeChatComposerProps = {
	right: {
		onLeadingIconPress: () => void;
		onTrailingIconPress: () => void;
	};
	onIconPress: () => void;
	ToolAction?: ToolActionProps;
	leadingText: string;
	trailingText: string;
	serchBarProps: SearchbarProps;
	onTextChange?: (text: string) => void;
	isMuted: boolean;
};

const VoiceModeChatComposer = (props: VoiceModeChatComposerProps) => {
	const theme = useAppTheme();
	const [isFocused, setIsFocused] = useState(false);
	const [searchText, setSearchText] = useState(props.serchBarProps.value);

	const shouldShowBorder = isFocused || searchText.length > 0;

	return (
		<Box paddingHorizontal={16} paddingTop={8}>
			<Box
				paddingTop={12}
				backgroundColor={theme.colors.secondaryContainer}
				borderRadius={40}
				borderTopLeftRadius={28}
				borderTopRightRadius={28}
				gap={8}
			>
				<Box
					paddingHorizontal={16}
					flexDirection="row"
					justifyContent="space-between"
				>
					<Text
						variant="labelSmall"
						style={{ color: theme.colors.secondary, alignSelf: "flex-start" }}
					>
						{props.leadingText}
					</Text>
					<Text
						variant="labelSmall"
						style={{ color: theme.colors.onSurface, alignSelf: "flex-end" }}
					>
						{props.trailingText}
					</Text>
				</Box>
				<Box
					borderWidth={2}
					borderColor={
						shouldShowBorder
							? theme.colors.primary
							: theme.colors.surfaceVariant
					}
					borderRadius={28}
					gap={8}
					backgroundColor={theme.colors.surfaceVariant}
				>
					{props.ToolAction && (
						<Box
							flexDirection="row"
							paddingHorizontal={16}
							paddingTop={16}
							gap={8}
						>
							<ToolAction
								key={props.ToolAction.text}
								icon={props.ToolAction.icon}
								text={props.ToolAction.text}
							/>
						</Box>
					)}
					<Searchbar
						style={{ backgroundColor: theme.colors.surfaceVariant }}
						inputStyle={{ color: theme.colors.onSurface }}
						onFocus={() => setIsFocused(true)}
						onIconPress={props.onIconPress}
						onBlur={() => setIsFocused(false)}
						onChangeText={(text) => {
							setSearchText(text);
							props.onTextChange?.(text);
						}}
						right={() => (
							<Box
								height={48}
								width={98}
								justifyContent="center"
								alignItems="center"
								flexDirection="row"
							>
								<Box
									width={48}
									height={48}
									justifyContent="center"
									alignItems="center"
								>
									<TooltipWrapper title={props.isMuted ? "Unmute" : "Mute"}>
										<TouchableOpacity onPress={props.right.onLeadingIconPress}>
											<Box
												borderRadius={100}
												width={40}
												height={40}
												backgroundColor={theme.colors.surfaceVariant}
												paddingHorizontal={2}
												justifyContent="center"
												alignItems="center"
											>
												<Icon
													name={props.isMuted ? "microphone-off" : "microphone"}
													size={24}
													color={
														props.isMuted
															? theme.colors.onSecondaryContainer
															: theme.colors.onSecondaryContainer
													}
												/>
											</Box>
										</TouchableOpacity>
									</TooltipWrapper>
								</Box>
								<TooltipWrapper title="End Call">
									<TouchableOpacity onPress={props.right.onTrailingIconPress}>
										<Box
											borderRadius={100}
											width={40}
											height={40}
											backgroundColor={theme.colors.errorContainer}
											paddingHorizontal={2}
											justifyContent="center"
											alignItems="center"
										>
											<Icon
												name={"phone-hangup"}
												size={24}
												color={theme.colors.onErrorContainer}
											/>
										</Box>
									</TouchableOpacity>
								</TooltipWrapper>
							</Box>
						)}
						{...props.serchBarProps}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default VoiceModeChatComposer;
